import { MessageCircle, Smile, Users } from "lucide-react";

export function ProductSections() {
  return (
    <>
      <section id="features" className="py-20 px-6 bg-white scroll-mt-24">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
              Why teams love Kyubot
            </h2>
            <p className="text-lg text-stone-600 max-w-xl mx-auto">
              Simple tools that make everyone's day a little easier.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: <MessageCircle className="w-6 h-6" />,
                color: "bg-blue-100 text-blue-600",
                title: "Works where you work",
                desc: "No new apps to learn. Just type commands in Slack like you're chatting with a friend.",
              },
              {
                icon: <Smile className="w-6 h-6" />,
                color: "bg-orange-100 text-orange-600",
                title: "Friendly notifications",
                desc: "Everyone stays in the loop. Requesters get updated automatically when their task is done.",
              },
              {
                icon: <Users className="w-6 h-6" />,
                color: "bg-emerald-100 text-emerald-700",
                title: "Team-first design",
                desc: "Assign tasks, track progress, and celebrate wins together. Built for collaboration.",
              },
            ].map((feature) => (
              <div key={feature.title} className="text-center p-6">
                <div
                  className={`w-14 h-14 ${feature.color} rounded-2xl flex items-center justify-center mx-auto mb-4`}
                >
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-stone-800 mb-2">{feature.title}</h3>
                <p className="text-stone-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-amber-50/50 border-y border-orange-200">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
              Perfect for any team
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { emoji: "🔍", title: "Code Review", desc: "Queue PRs efficiently" },
              { emoji: "🐛", title: "Bug Triage", desc: "Capture and close the loop" },
              { emoji: "🎨", title: "Design Requests", desc: "Manage creative work" },
              { emoji: "📋", title: "Operations", desc: "Manage access requests" },
              { emoji: "💻", title: "IT Support", desc: "Track helpdesk tickets" },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-white p-6 rounded-2xl shadow-sm border border-orange-200 text-center hover:shadow-md transition-shadow"
              >
                <span className="text-4xl mb-4 block">{item.emoji}</span>
                <h3 className="font-bold text-stone-800 mb-1">{item.title}</h3>
                <p className="text-sm text-stone-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
